import * as React from "react";

export interface IModelPortfolioSlider {
    sliderValue: number;
    onChange: (value: any) => void;
}

export const ModelPortfolioSlider: React.FunctionComponent<IModelPortfolioSlider> = (props) => {
    const renderMarkerIndicator = (className: string) => {
        return <span className={`model-portfolio-slider__marker-indicator ${className}`}>|</span>;
    };

    const renderMarkerValue = (value: number, className?: string) => {
        return <span className={`model-portfolio-slider__marker-value ${className}`} data-testid="model-portfolio-slider__marker">
                {value}%
            </span>;
    };

    return (
        <div className={"model-portfolio-slider__main-container"}>
            <div className={"model-portfolio-slider__container"}>
                <div className={"model-portfolio-slider__thumb-tooltip"}
                     style={{left: `${props.sliderValue * 93 - 9.5}%`}}
                     data-testid="model-portfolio-slider__thumb-tooltip">
                    {props.sliderValue.toFixed(2)}%
                </div>
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    list="marks"
                    value={props.sliderValue}
                    onChange={(e) => props.onChange(parseFloat(e.target.value))}
                    className={"model-portfolio-slider__input"}
                />
                <div className={"model-portfolio-slider__marker-container"}>
                    <div className={"model-portfolio-slider__marker-indicator-container"}>
                        {renderMarkerIndicator("first")}
                        {renderMarkerIndicator("")}
                        {renderMarkerIndicator("last")}
                    </div>
                    <div className={"model-portfolio-slider__marker-value-container"}>
                        {renderMarkerValue(0, "first")}
                        {renderMarkerValue(0.5)}
                        {renderMarkerValue(1, "last")}
                    </div>
                </div>
            </div>
        </div>
    );
};